export default __webpack_public_path__ + "static/media/warn.9aedc0f7.svg";